export const PARCEL_STATUS = {
  NEW: 0, // Ожидаем
  PREPAYMENT_INVOICE: 1, // Получили
  PACKAGING: 2, // На упаковке
  EXECUTING: 3, // Отправили
  FINAL_INVOICE: 4, // Готов к выдаче / Оплачен
  ON_DELIVERY: 5, // На доставке
  WON: 6, // Выполнен (Доставлен)
  LOSE: 7, // Отменен
} as const

export const PARCEL_STATUS_SLUG = {
  new: PARCEL_STATUS.NEW,
  'prepayment-invoice': PARCEL_STATUS.PREPAYMENT_INVOICE,
  packaging: PARCEL_STATUS.PACKAGING,
  executing: PARCEL_STATUS.EXECUTING,
  'final-invoice': PARCEL_STATUS.FINAL_INVOICE,
  'on-delivery': PARCEL_STATUS.ON_DELIVERY,
  won: PARCEL_STATUS.WON,
  lose: PARCEL_STATUS.LOSE,
} as const

export const DELIVERY_SERVICE = {
  FEDEX: 'fedex',
  DHL: 'dhl',
  ONTRAC: 'ontrac',
  USPS: 'usps',
  UPS: 'ups',
} as const

export const DELIVERY_TYPE = {
  DELIVERY: 0,
  PICKUP: 1,
} as const

// Cities
export const REGION_IDS = {
  ALMATY: 1,
  BISHKEK: 2,
} as const

export const COUNTRIES_BY_REGION_ID = {
  '1': 'kz',
  '2': 'kg',
} as const

export const REGION_ID_BY_COUNTRY_CODE = {
  kz: REGION_IDS.ALMATY,
  kg: REGION_IDS.BISHKEK,
} as const

// Re-export constants from generated types if they exist
export * from '@/generated/types'
